// extracted by mini-css-extract-plugin
export default {"box":"app_box__z4fIu","main":"app_main__E1b33","ul":"app_ul__rU2Fz","li":"app_li__eogcJ","button":"app_button__saC-O"};